require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-el-nuevo-marco-ambiental-y-social-mas-flexible-del.json") })
        }
      }, "path---es-mx-update-el-nuevo-marco-ambiental-y-social-mas-flexible-del");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-el-nuevo-marco-ambiental-y-social-mas-flexible-del!./.cache/json/es-mx-update-el-nuevo-marco-ambiental-y-social-mas-flexible-del.json
// module id = 929
// module chunks = 231608221292675